export { default } from "./AllOnFour";
